import { memo, useEffect } from 'react';

import type { LOGIN_FAILURE_REASONS } from '@didaskill/domain/auth/constants';
import { useGoogleIdentityLoaded } from '@didaskill/ui/domain';

import { LoginFooter } from './components/login-footer/LoginFooter';
import { LoginGoogleCard } from './components/login-google-card/LoginGoogleCard';
import { LoginHeader } from './components/login-header/LoginHeader';
import { LoginPageSocialMedias } from './components/social-medias/LoginSocialMedias';
import * as styles from './LoginPage.styles';

const e = encodeURIComponent;

declare global {
  interface Window {
    // google type is imported from tsconfig.
    google: typeof google;
  }
}

export type LoginPageProps = {
  error?: boolean;
  reason?: LOGIN_FAILURE_REASONS;
};

export const LoginPageBase = ({ error = false, reason = null }: LoginPageProps) => {
  const isGoogleLoaded = useGoogleIdentityLoaded();

  useEffect(() => {
    if (isGoogleLoaded) {
      window.google.accounts.id.initialize({
        client_id: window.env.OAUTH_GOOGLE_CLIENT_ID,
        cancel_on_tap_outside: false,
        use_fedcm_for_button: true,
        use_fedcm_for_prompt: true,
        callback: (response) => {
          window.location.href = `/auth/google/callback?state=${e(
            window.location.href,
          )}&token=${e(response.credential)}`;
        },
      });
      window.google.accounts.id.renderButton(document.getElementById('g_id_onload'), {
        theme: 'outline',
        size: 'large',
        type: 'standard',
      });
      window.google.accounts.id.prompt();
    }
  }, [isGoogleLoaded]);

  return (
    <div css={styles.container}>
      <LoginHeader />

      <div css={styles.body}>
        <LoginGoogleCard hasError={error} reason={reason} />
      </div>
      <div css={styles.socialMedias}>
        <LoginPageSocialMedias />
      </div>

      <LoginFooter />
    </div>
  );
};

LoginPageBase.displayName = 'LoginPage';

export default memo(LoginPageBase);
